import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const FavoriteButton = ({ isFavorite, onClick, size = 'small' }) => {
  return (
    <Tooltip title={isFavorite ? 'Von Favoriten entfernen' : 'Zu Favoriten hinzufügen'}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        size={size}
        sx={{
          color: isFavorite ? '#ffa726' : 'rgba(0, 0, 0, 0.26)',
          '&:hover': {
            color: isFavorite ? '#fb8c00' : 'rgba(0, 0, 0, 0.54)',
            backgroundColor: isFavorite ? 'rgba(255, 167, 38, 0.08)' : 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        {isFavorite ? <StarIcon /> : <StarBorderIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;
